module.exports = __webpack_public_path__ + "img/1018.26f19671.png";